export const FORM_INPUT_DATA_UPDATED = "Form Input Data Updated"
export const CARD_DATA_UPDATED = "Card Data Updated"

export const PaymentFormActions = {

    /**
     * Dispatches an action that updates the state of the form input card data.
     *
     * @param cardInfo: {Object} containing a single element to be added to the formInputData.cardData state.
     */
    cardDataUpdated: (cardInfo) => dispatch => {
        let action = createAction(CARD_DATA_UPDATED, {cardInfo})
        dispatch(action)
    },

    /**
     * Dispatches an action that updates the state of the form input data.
     *
     * @param inputInfo: {Object} containing a single element to be added to the formInputData state.
     */
    formInputDataUpdated: inputInfo => dispatch => {
        let action = createAction(FORM_INPUT_DATA_UPDATED, {inputInfo})
        dispatch(action)
    }
}

function createAction(type, actionParameters = {}) {
    return {type, ...actionParameters}
}
